export enum NavItemsId {
  HOME = 'HOME',

  // NAVBAR ====================================================================
  LOGO = 'LOGO',
  MENU = 'MENU',
  LINK = 'LINK',
  USER = 'USER',
  PROFILE = 'PROFILE',
  DOWNLOAD_MANUAL = 'DOWNLOAD_MANUAL',
  SIGNOUT = 'SIGNOUT',
  ALARM = 'ALARM',
  THEME = 'THEME',
  SUPPORT = 'SUPPORT',
  REMINDER = 'REMINDER',
  ADMINISTRATION_AND_CONFIGURATION = 'ADMINISTRATION_AND_CONFIGURATION',
  ANY_PERMISSION = 'ANY_PERMISSION',

  // SIDEBAR ===================================================================
  TOGGLE = 'TOGGLE',

  // User =========================
  WORKSPACE = 'WORKSPACE',
  TUTORIALS = 'TUTORIALS',
  DATA_PROTECTION_GOVERNANCE = 'DATA_PROTECTION_GOVERNANCE',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  REGULATIONS = 'REGULATIONS',
  PROJECT_CARDS = 'PROJECT_CARDS',
  APPOINTMENTS = 'APPOINTMENTS',
  PURPOSE_CATEGORIES = 'PURPOSE_CATEGORIES',
  TREATMENT_CATEGORY = 'TREATMENT_CATEGORY',
  DEPARTMENTS = 'DEPARTMENTS',
  APPLICATIONS = 'APPLICATIONS',
  RECIPIENTS = 'RECIPIENTS',
  NOTICES = 'NOTICES',
  ORGANIZATION = 'ORGANIZATION',
  REGISTERS_AND_APPOINTMENTS = 'REGISTERS_AND_APPOINTMENTS',
  OTHER_MODULES = 'OTHER_MODULES',
  COVID_ASSESSMENTS = 'COVID_ASSESSMENTS',
  COVID_TEMPLATE = 'COVID_TEMPLATE',
  RISK_ASSESSMENT_AND_DPIA = 'RISK_ASSESSMENT_AND_DPIA',
  ASSET = 'ASSET',
  PROCESS = 'PROCESS',
  ORGANIZATIONAL_FUNCTIONS = 'ORGANIZATIONAL_FUNCTIONS',
  NATURE_OF_DATA = 'NATURE_OF_DATA',
  EMPLOYMENT_RELATIONSHIP = 'EMPLOYMENT_RELATIONSHIP',
  LEGAL_BASIS = 'LEGAL_BASIS',
  INTERESTED_PERSON_CATEGORY = 'INTERESTED_PERSON_CATEGORY',
  SUPPLIERS = 'SUPPLIERS',
  APPLICATION_TYPES = 'APPLICATION_TYPES',
  BUSINESS_MANAGEMENT = 'BUSINESS_MANAGEMENT',
  PRIVACY_ROLES = 'PRIVACY_ROLES',
  TREATMENTS_HOLDER = 'TREATMENTS_HOLDER',
  TREATMENTS_RESPONSIBLE = 'TREATMENTS_RESPONSIBLE',
  TREATMENTS_SUB_RESPONSIBLE = 'TREATMENTS_SUB_RESPONSIBLE',
  APP_ASSESSMENTS = 'APP_ASSESSMENTS',
  AI_ASSESSMENTS = 'AI_ASSESSMENTS',
  PRELIMINARY_RISK_ASSESSMENTS = 'PRELIMINARY_RISK_ASSESSMENTS',
  SECURITY_MEASURES = 'SECURITY_MEASURES',
  SECURITY_MEASURE_CATEGORIES = 'SECURITY_MEASURE_CATEGORIES',
  GLOBAL_MEASURE_CHECK = 'GLOBAL_MEASURE_CHECK',
  TECHNICAL_MEASURE_CATEGORIES = 'TECHNICAL_MEASURE_CATEGORIES',
  TECHNICAL_MEASURES = 'TECHNICAL_MEASURES',

  DAMAGES = 'DAMAGES',

  MAIL_HISTORY = 'MAIL_HISTORY',

  PERMISSION_RULES = 'PERMISSION_RULES',

  // Administation ================
  USERS = 'USERS',
  USER_GROUPS = 'USER_GROUPS',
  USERS_RESOURCES = 'USERS_RESOURCES',
  SETTINGS = 'SETTINGS',
  IMPORT_BUTTON = 'IMPORT_BUTTON',
  CREATE_BUTTON = 'CREATE_BUTTON',
  DELETE_BUTTON = 'DELETE_BUTTON',
  RELOAD_BUTTON = 'RELOAD_BUTTON',
  EXPORT_TABLE_BUTTON = 'EXPORT_TABLE_BUTTON',
  EXPORT_RAW_BUTTON = 'EXPORT_RAW_BUTTON',

  NEW_FOLDER = 'NEW_FOLDER',
  NEW_HOLDER_REGISTER = 'NEW_HOLDER_REGISTER',
  NEW_RESPONSIBLE_REGISTER = 'NEW_RESPONSIBLE_REGISTER',
  NEW_SUB_RESPONSIBLE_REGISTER = 'NEW_SUB_RESPONSIBLE_REGISTER',

  NEW_AI = 'NEW_AI',
  NEW_PROJECT_CARD = 'NEW_PROJECT_CARD',
  NEW_GLOBAL_MEASURE_CHECK = 'NEW_GLOBAL_MEASURE_CHECK',
  NEW_APP_ASSESSMENT = 'NEW_APP_ASSESSMENT',
  NEW_LEGAL_ENTITY = 'NEW_LEGAL_ENTITY',

  NEW_COVID_ASSESSMENT = 'NEW_COVID_ASSESSMENT',
  DOWNLOAD = 'DOWNLOAD',
  STORAGE = 'STORAGE',

  ASSESSMENT_QUESTION = 'ASSESSMENT_QUESTION',

  // Console UI
  CUSTOMERS = 'CUSTOMERS',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SECURITY_CENTER = 'SECURITY_CENTER',
  TOOLS = 'TOOLS',
  MANAGEMENT_TEMPLATE = 'MANAGEMENT_TEMPLATE',

  // Custom
  CANDIDATES = 'CANDIDATES',

  //LEGAL ENTITY
  EXTERNAL = 'EXTERNAL',

  //For AppAssessment
  INTERNAL = 'INTERNAL',
  PRIMATOO = 'PRIMATOO',
  SUPPLIER = 'SUPPLIER',

  SECURITY_INCIDENT = 'SECURITY_INCIDENT',
  DATA_BREACHES = 'DATA_BREACHES',
  GENERIC_REPORT = 'GENERIC_REPORT',
  REPORTS = 'REPORTS',
  INCIDENT_TEAM = 'INCIDENT_TEAM',
  GUARANTOR_CATEGORY = 'GUARANTOR_CATEGORY',
  RESET = 'RESET',
  SAVE = 'SAVE',
  OBSOLETE = 'OBSOLETE',

  GUARANTEED_CATEGORY = 'GUARANTEED_CATEGORY',
  CYBER_SECURITY = 'CYBER_SECURITY',
  DPIA = 'DPIA',
  LIA = 'LIA',
  EXTRACTION = 'EXTRACTION',
  DEBUG = 'DEBUG',
}
